import { render, staticRenderFns } from "./BookingTravellerTravelInfo.vue?vue&type=template&id=5840dfa8&scoped=true&"
import script from "./BookingTravellerTravelInfo.vue?vue&type=script&lang=js&"
export * from "./BookingTravellerTravelInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingTravellerTravelInfo.vue?vue&type=style&index=0&id=5840dfa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840dfa8",
  null
  
)

export default component.exports